import { Council, Society } from 'types';
import { generateDocumentFromTemplate } from 'utils/generateDocumentFromTemplate.ts';

type Props = {
  announcementTemplateId?: string;
  actTemplateId?: string;
  certificationTemplateId?: string;
  society: Society;
  council: Council;
  userId: string;
  hasCouncilsV2Enabled?: boolean;
};

export const generateCouncilDocuments = async ({
  announcementTemplateId,
  actTemplateId,
  certificationTemplateId,
  society,
  council,
  userId,
  hasCouncilsV2Enabled = false,
}: Props) => {
  let announcementDocumentId;
  let actDocumentId;
  let certificationDocumentId;

  if (announcementTemplateId && hasCouncilsV2Enabled) {
    const announcementDocument = await generateDocumentFromTemplate({
      templateId: announcementTemplateId,
      society,
      council,
      userId,
    });
    announcementDocumentId = announcementDocument?._id;
  }

  if (actTemplateId) {
    const actDocument = await generateDocumentFromTemplate({
      templateId: actTemplateId,
      society,
      council,
      userId,
    });
    actDocumentId = actDocument?._id;
  }

  if (certificationTemplateId) {
    const certificationDocument = await generateDocumentFromTemplate({
      templateId: certificationTemplateId,
      society,
      council,
      userId,
    });
    certificationDocumentId = certificationDocument?._id;
  }

  return {
    announcementTemplateId,
    announcementDocumentId,
    actDocumentId,
    certificationDocumentId,
  };
};
